import type { Vec } from './types';

export const FILES = 'abcdefghijklmnop';
export const MIN_SIZE = 4;
export const MAX_SIZE = 16;

export const ORTHO: Vec[] = [[1, 0], [-1, 0], [0, 1], [0, -1]];
export const DIAG: Vec[] = [[1, 1], [-1, 1], [1, -1], [-1, -1]];
export const DIRS8: Vec[] = [...ORTHO, ...DIAG];
export const KNIGHT: Vec[] = [
  [1, 2], [2, 1], [-1, 2], [-2, 1], [1, -2], [2, -1], [-1, -2], [-2, -1],
];

export function sqName(sq: number, w: number): string {
  return FILES[sq % w] + (Math.floor(sq / w) + 1);
}

export function parseSq(name: string, w: number, h: number): number {
  const m = /^([a-p])(\d{1,2})$/.exec(name.trim().toLowerCase());
  if (!m) return -1;
  const x = FILES.indexOf(m[1]);
  const y = parseInt(m[2], 10) - 1;
  if (x < 0 || x >= w || y < 0 || y >= h) return -1;
  return y * w + x;
}

export const sqX = (sq: number, w: number) => sq % w;
export const sqY = (sq: number, w: number) => Math.floor(sq / w);

export function offset(sq: number, dx: number, dy: number, w: number, h: number): number {
  const x = (sq % w) + dx;
  const y = Math.floor(sq / w) + dy;
  if (x < 0 || x >= w || y < 0 || y >= h) return -1;
  return y * w + x;
}

export function chebyshev(a: number, b: number, w: number): number {
  return Math.max(Math.abs((a % w) - (b % w)), Math.abs(Math.floor(a / w) - Math.floor(b / w)));
}

/** All 8 mirror/rotation images of a vector, deduplicated. */
export function symmetric(v: Vec): Vec[] {
  const [a, b] = v;
  const all: Vec[] = [
    [a, b], [-a, b], [a, -b], [-a, -b], [b, a], [-b, a], [b, -a], [-b, -a],
  ];
  const seen = new Set<string>();
  return all.filter(([x, y]) => {
    const k = `${x},${y}`;
    if (seen.has(k) || (x === 0 && y === 0)) return false;
    seen.add(k);
    return true;
  });
}
